import { save, load } from "redux-localstorage-simple"
import { LOCAL_STORAGE, LOCAL_STORAGE_VERSION } from "./StorageEngineKeys";

export const stateFilters = [
    "home.menuItems",
    "home.currentPage",
    "repertoire.resultsPerPage",
    "repertoire.productMaintenanceSubmissionConfig",
    "repertoire.defaultActiveAccordions",
    "repertoire.matchingSourceTreeData",
    "usage.resultsPerPage",
    "dataIngestion.distributions",
    "dataIngestion.formats",
    "dataIngestion.sources",
    "dataIngestion.destinations",
    "membersPortal.resultsPerPage",
    "membersPortal.defaultActiveAccordions",
];

const localStorageVersion: number = 377;
const existingVersion: number = Number(localStorage[LOCAL_STORAGE_VERSION]);
if (!existingVersion || existingVersion < localStorageVersion && localStorage) {
    localStorage.removeItem(LOCAL_STORAGE);
    localStorage.setItem(LOCAL_STORAGE_VERSION, localStorageVersion.toString());
}

const saveStorageMiddleware = save({ states: stateFilters });
let isStorageQuotaExceeded = false;

export const saveStorage = store => next => action => {
    if (isStorageQuotaExceeded) {
        return next(action);
    }

    try {
        return saveStorageMiddleware(store)(next)(action);
    } catch (error) {
        const storageError = error as { name?: string; code?: number };
        const isQuotaError =
            storageError?.name === "QuotaExceededError"
            || storageError?.code === 22
            || storageError?.code === 1014;

        if (isQuotaError) {
            isStorageQuotaExceeded = true;
            return next(action);
        }

        throw error;
    }
};

export const loadStorage = store => next => action => {
    load({ states: stateFilters, disableWarnings: true })
    return next(action);
}
